import { motion, AnimatePresence } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';

import { Advt } from './components/Advt/Advt';
import { MessagesList } from './components/MessagesList/MessagesList';

function App() {
  const { showedMessages, speed, currentState, prevState } = useCarousel();

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <AnimatePresence mode="popLayout">
        {currentState === 'S1' && (
          <motion.div
            key="advt"
            exit={{ opacity: 0, transition: { delay: 0.5 } }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="motionBlock"
          >
            <Advt />
          </motion.div>
        )}

        {currentState === 'S2' && (
          <motion.div
            key="msgs"
            className="motionBlock"
            initial={{ y: !prevState ? '0' : '100vh' }}
            animate={{ y: '0' }}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.5 }}
            style={{ zIndex: 15 }}
          >
            <MessagesList
              messages={showedMessages}
              currentState={currentState}
              speed={speed || 0}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
